

import * as THREE from "three";
import React, { useRef } from 'react'
import {  useFrame } from '@react-three/fiber'
import { lerp3 } from '../../Utils';
import Phone from "./Phone";
import Character from "./Character";

export default function Group1(props) {

  
   // useHelper for debug
    const group = useRef()

    useFrame(() => {
       
       var currentPos = new THREE.Vector3(0,0,-0.2);
       var targetPos = new THREE.Vector3(0,0,-0.5)

       var time = ( (window.scrollY ) / window.innerHeight);

        if(time < 1)
            group.current.position.copy(lerp3(currentPos, targetPos,time ))

    })


    return (


        <group

            {...props}
            scale = {[1.1,1.1,1.1]}
            ref={group}
                
        >

            <Phone
                {...props}
                index = {1}
                scrollIndex = {props.scrollIndex}
            >

            </Phone>

            <Character
                {...props}
            />
        </group>
        
  );
}